import { ofType } from 'redux-observable';
import { of } from 'rxjs/observable/of';
import { catchError } from 'rxjs/operators/catchError';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { AuthService } from '../../services';
import {
  types as actions,
  loggedInAction,
  loginErrorAction
} from '../../reducers/actions';

export default function(action$) {
  return action$.pipe(
    ofType(actions.LOG_IN),
    switchMap(action =>
      AuthService.authenticate(action.username, action.password).pipe(
        map(data =>
          loggedInAction(
            data.response.access_token,
            data.response.refresh_token,
            data.response.expires_in,
            data.response.scope
          )
        ),
        catchError(error => of(loginErrorAction(error)))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/auth/login.js